import { searchContextItems, type SearchContextType } from '@gat-ship/types'
import { searchContextMetadata } from './global-search-context-metadata'

export interface ParsedContextPrefix {
  context: SearchContextType
  /** The input text with the matched prefix stripped (original casing kept). */
  remainder: string
}

/**
 * The tag-input rule: an input starting with a context prefix followed
 * by `:` (case-insensitive, e.g. `c:` or `CT:`) selects that context.
 * Returns `undefined` when the input doesn't start with a known prefix.
 */
export function parseContextPrefix(
  input: string
): ParsedContextPrefix | undefined {
  const lowerInput = input.toLowerCase()
  for (const context of Object.values(searchContextItems)) {
    const prefix = `${searchContextMetadata[context].prefix.toLowerCase()}:`
    if (lowerInput.startsWith(prefix)) {
      return { context, remainder: input.slice(prefix.length) }
    }
  }
  return undefined
}
